import { z } from 'zod';

/** Built-in demo principals for RLS isolation demos (see seed + test:rls). */
export const DEMO_OWNERS = {
  'demo-key-a': '11111111-1111-1111-1111-111111111111',
  'demo-key-b': '22222222-2222-2222-2222-222222222222',
} as const;

export type DemoOwnerKey = keyof typeof DEMO_OWNERS;

export const AuthTokenResponse = z
  .object({
    token: z.string().min(1),
    expiresIn: z.number().int().positive(),
    ownerId: z.string().uuid(),
  })
  .strict();

export type AuthTokenResponse = z.infer<typeof AuthTokenResponse>;

export const CreateApiKeyInput = z
  .object({
    label: z.string().trim().min(1).max(80),
  })
  .strict();

export type CreateApiKeyInput = z.infer<typeof CreateApiKeyInput>;

export const ApiKeySummary = z
  .object({
    id: z.string().uuid(),
    label: z.string(),
    keyPrefix: z.string(),
    createdAt: z.string(),
    revokedAt: z.string().nullable(),
  })
  .strict();

export type ApiKeySummary = z.infer<typeof ApiKeySummary>;

export const CreateApiKeyResponse = z
  .object({
    id: z.string().uuid(),
    label: z.string(),
    key: z.string().min(1),
    keyPrefix: z.string(),
    createdAt: z.string(),
  })
  .strict();

export type CreateApiKeyResponse = z.infer<typeof CreateApiKeyResponse>;
